module.exports = __webpack_public_path__ + "static/img/higashi_03.94301e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/higashi_03.png
// module id = CM43
// module chunks = 0